import { Route, RouteProps } from 'react-router-dom';

import { Permission } from '__generated__/graphql';

import NotAuthorisedPage from './Errors/NotAuthorisedPage';
import ProtectedSection from './ProtectedSection';

interface ProtectedRouteProps extends RouteProps {
  permissions: Permission[];
}

const ProtectedRoute = ({ permissions, ...props }: ProtectedRouteProps) => (
  <ProtectedSection permissions={permissions} fallback={<NotAuthorisedPage />}>
    <Route {...props} />
  </ProtectedSection>
);

export default ProtectedRoute;
